/* tslint:disable */
/* eslint-disable */
export enum WorkProjectCheckStatusEnum {
  None = 'NONE',
  Ok = 'OK',
  Warning = 'WARNING',
  Problem = 'PROBLEM'
}
